import React, { useState } from 'react';
import SelectElem from './SelectElem';
import styles from './index.module.scss';
const Select = ({ onClick, selectList, isSelectableAll, defaultActiveID, isFullWidth }) => {
    const [selectedSingleID, setSingleSelected] = useState(defaultActiveID || null);
    const [selectedMultiIDs, setMultiSelected] = useState([]);
    const _handleSelect = (e) => {
        var _a;
        if (!e.target || !e.target.dataset) {
            return;
        }
        const { id } = (_a = e.target) === null || _a === void 0 ? void 0 : _a.dataset;
        const elemID = Number(id);
        if (isSelectableAll) {
            const tempMultiSelectedIDs = [...selectedMultiIDs];
            selectList.forEach((select) => {
                if (elemID !== select.id) {
                    return;
                }
                tempMultiSelectedIDs.push(elemID);
            });
            const normalizedList = [...new Set(tempMultiSelectedIDs)];
            // check is the same elem was clicked one more time (e.g. unselected)
            if (selectedMultiIDs.some((key) => key === elemID)) {
                setMultiSelected(normalizedList.filter((key) => key !== elemID));
                return;
            }
            setMultiSelected(normalizedList);
        }
        else {
            setSingleSelected(elemID);
        }
        onClick && onClick(e);
    };
    const selectsToRender = selectList.map((select) => {
        const isSelected = isSelectableAll ?
            selectedMultiIDs.find((key) => key === select.id) :
            selectedSingleID === select.id;
        return (React.createElement(SelectElem, { key: select.id, onClick: _handleSelect, isSelected: isSelected, id: select.id, isDisabled: select.isDisabled, label: select.label }));
    });
    return (React.createElement("div", { className: `${styles.selectsWrap} ${styles[`x${selectList.length}`]} ${isFullWidth ? styles.fullWidth : ''}` }, selectsToRender));
};
export default Select;
